import OptionToggler from "../../OptionToggler";

const options = [
  { value: "weight", label: "Weight" },
  { value: "drop", label: "%Mod." },
];

const LoadToggler = ({
  isAssistant,
  preferredLoadInput,
  setPreferredLoadInput,
}) => {
  return (
    <div>
      <label htmlFor="loadType" className="invisible">
        Load type
      </label>
      <OptionToggler
        name="loadType"
        defaultValue={isAssistant ? "weight" : preferredLoadInput}
        onSelectFn={setPreferredLoadInput}
        options={
          isAssistant
            ? options
            : [{ value: "percent", label: "%1RM" }, ...options]
        }
      />
    </div>
  );
};

export default LoadToggler;
